import BaseModel from '../base/BaseModel.model';
import { ReportEvaluationState } from '@/enums/ReportEvaluationState';
export default class BudgetSubItemEvaluation extends BaseModel {

    public reason:string = null;
    public budgetItemEvaluationId:number = 0;
    public proposalBudgetSubItemExecutionId:number = 0;
    public state:ReportEvaluationState = ReportEvaluationState.Pendiente;
    public identifierUI: string= "";
    public stateUI:ReportEvaluationState = ReportEvaluationState.Pendiente;
   
    constructor(){
       super();
       this.init();
    }

    init(){
        this.state = ReportEvaluationState.Pendiente;
    }
}